import { MainLayout } from "~/components";
import { useEffect, useRef } from "react";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { HeroPage } from "./HeroPage";
import { KeyBenefitsPage } from "./keyBenefits";
import { Elearning } from "./E-Learning";
import { EcosystemFriendly } from "./EcoSystem";
import { DLAbanner } from "./DLABanner";
import { Maindla } from "./DLA";
import { dlaLine } from "~/assets";
import { Skillsection } from "./SkillsUtility";
import { TokenomicSection } from "./Tokenomics";
import { Roadmap } from "./RoadMap";
import { TeamSection } from "./Team";
import { Partnersection } from "./Partners";
import { CommunityPage } from "./DLA/CommunityPage";
import { Header } from "../../components/MainLayout/Header"
import { Footer } from "../../components/MainLayout/Footer"
import Box from "@material-ui/core/Box";
import { Container } from '@mui/material';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "black",
  },
  container:{
    display:"inherit",
    [theme.breakpoints.up('xl')]:{
      display:"flex",
      alignItems:"center", 
      flexDirection:"column", 
      justifyContent:"center"
    },
  }
}));

export const HomePage = () => {
  const classes = useStyles();

  // const roadmapRef = useRef(null)

  // function handleBackClick(){
  //   window.scrollTo(0, roadmapRef.current.offsetTop)
  // }

 
  return (
    // <MainLayout>
    //   <HeroPage />
    //   <KeyBenefitsPage />
    //   <Elearning />
    //   <EcosystemFriendly />
    //   <DLAbanner />
    //   <Maindla />
    //   <CommunityPage />
    //   <Skillsection />
    //   <TokenomicSection />
    //   <Roadmap />
    //   <TeamSection />
    //   <Partnersection />
    // </MainLayout>

    
      <> 
        <Container disableGutters={true} 
        sx={{maxWidth: '100% !important', 
        alignItems:'center !important',
        display:'flex', flexDirection:'column'}}>
        <Header/>
          <HeroPage />
          <KeyBenefitsPage />
          <Elearning />
          <EcosystemFriendly />
          <DLAbanner />
          <Maindla />
          <CommunityPage />
          <Skillsection />
          <TokenomicSection />
          <Roadmap/>
          <TeamSection />
          <Partnersection />
        <Footer />
        </Container>
      </>
  );
};
